@import "styles/variables";

.attributes-container {
  display: flex;
  flex-direction: column;
  margin: 20px 0 0;
}
.attributes-wrapper {
  overflow: hidden;
}
.attribute {
  float: left;
  display: flex;
  align-items: center;
  width: 33%;
  margin-bottom: 8px;
}
.attribute label {
  flex: 1 auto;
  display: flex;
  align-items: center;
  color: var(--color-black);
  margin-left: 9px;
}
.disabled {
  opacity: .3;
  pointer-events: none;
}
.row {
  display: flex;
  margin-bottom: 5px;
}
.row h2 {
  line-height: 20px;
}
.row span {
  line-height: 20px;
  margin-left: 10px;
  font-family: var(--font-stack-default);
  font-size: 11px;
  color: var(--color-black-transparent);
  font-weight: 400;
}
